export default new Map([
  [
    'restaurant',
    {
      to: '/restaurant',
      text: 'restaurant',
      image: 'restaurantCardImage'
    }
  ],
  [
    'docking',
    {
      to: '/docking',
      text: 'yachtDocking',
      image: 'dockingCardImage'
    }
  ],
  [
    'accommodation',
    {
      to: '/accommodation',
      text: 'accommodation',
      image: 'accommodationCardImage'
    }
  ],
  [
    'tours',
    {
      to: '/tours',
      text: 'adventureTours',
      image: 'toursCardImage'
    }
  ]
])



// WEBPACK FOOTER //
// ./src/data/pages.js